var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbast05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-vectorizado-gabinete-t\xE9cnico-agricola") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.38108145%",
    y1: "62.2092143%",
    x2: "95.4467298%",
    y2: "33.5296966%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C359",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B9247",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "80.0109871%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C359",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B9247",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "76.4321379%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C359",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B9247",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C359",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B9247",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "79.8632635%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C359",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B9247",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-vectorizado-gabinete-t\\xE9cnico-agricola",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Campo-+-hojas",
    transform: "translate(97.469463, 119.585043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.296807,134.291236 C157.915065,139.702269 152.126079,145.912754 147.068414,152.796463 C145.005318,156.381378 140.94071,157.904546 137.299499,156.457116 C130.617531,154.454276 123.612241,154.058757 116.77631,155.304221 C107.323019,156.659083 97.8466324,153.015261 91.2570414,145.49199 C82.4195993,135.848065 78.8399733,124.016164 76.5305372,109.878472 C87.8005854,120.044146 101.557126,119.867424 113.743251,124.108732 C122.188089,127.104576 128.084849,135.444131 128.623718,145.121717 C128.646812,149.009582 126.368168,148.024993 124.297374,147.250786 C117.122726,144.801936 110.171323,141.62937 103.543241,137.758336 C107.269132,141.477895 111.672457,144.305433 116.460687,146.047399 C121.749296,148.52991 127.238056,150.490673 132.857684,151.887612 C135.667498,152.594496 137.276405,152.131655 136.160177,148.824445 C133.858439,141.620955 132.149457,134.215498 131.064022,126.675396 C130.509757,123.284033 127.838509,121.348516 125.875489,118.975403 C103.789581,92.282096 104.751846,65.1764393 122.696165,38.3653179 C132.934665,23.4954963 145.628865,10.8388966 160.116728,1.06032684 C160.740276,0.664808097 161.386918,0.311365817 162.056654,0 C163.326844,0.715299851 163.026617,1.51475263 162.695598,2.27212894 C157.376197,14.1545218 158.053632,26.3987721 160.817257,38.6346072 C163.757939,51.6446492 167.237489,64.562123 170.170473,77.5805803 C173.588438,92.8122595 167.168206,104.585253 155.998233,114.338577 C152.772721,116.964149 149.400944,119.379337 145.905998,121.567313 C143.304033,123.309279 141.464182,122.602394 140.902219,119.488736 C139.616633,114.052457 138.708255,108.515195 138.169387,102.927441 C136.914593,85.7939056 138.015424,68.5593869 141.441088,51.7792939 C141.741315,50.4833389 141.733616,49.1200615 141.417994,47.8241065 C138.477312,54.9602744 136.445008,62.4919611 135.374969,70.2256148 C132.026287,94.9918202 133.858439,120.271358 140.732861,144.153958 C141.163956,145.643465 141.06388,147.881933 142.903731,148.260621 C144.481845,148.588817 144.989921,146.36718 146.160036,145.576143 C152.795815,141.065546 154.912798,134.156591 157.314612,127.012008 C163.71175,108.052354 178.353575,99.2667887 197.62197,97.4070091 C210.908926,96.4560811 224.249768,98.1475548 236.982459,102.397277 C237.875441,102.834873 238.729933,103.356621 239.530537,103.954107 C227.667734,107.875633 220.000406,115.903822 212.85655,124.613649 C209.092169,129.216814 205.181524,133.71058 201.193898,138.137024 C190.955398,149.480838 177.044894,150.625318 163.673259,145.912754 C160.2322,144.692537 160.078237,143.295598 162.40307,140.661612 C170.924889,131.581511 180.7092,124.032994 191.386493,118.30218 C193.087777,117.326006 194.79676,116.349832 196.498045,115.373658 C184.673732,119.152125 173.711608,125.598239 164.296807,134.291236 Z",
    id: "Hojas",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Campo-inferior",
    transform: "translate(-0.000000, 141.115380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19202956,-2.84217094e-14 C77.8363525,11.3832032 106.993988,16.568438 174.238181,40.7562251 C241.482373,64.9440122 284.746441,94.245555 319.609414,120.654553 C309.625721,136.75141 297.963986,151.191211 271.302478,170.945325 C230.484855,126.290062 191.892217,95.2747227 149.974252,69.8416739 C103.767807,41.8066594 55.6731684,24.4660691 0.458652992,14.825585 C0.704583144,10.2886287 1.2765398,6.05523852 2.19202956,-2.84217094e-14 Z",
    id: "Path-4",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.458652992,14.825585 C133.710472,43.574248 215.197508,124.693134 260.660445,177.276464 C199.890645,214.14065 113.792361,206.031424 64.5460232,162.928737 C15.299685,119.826051 4.55701657,76.5241625 0.950279052,45.3452399 C95.5223154,86.9675225 143.263339,150.693518 153.616066,179.416395 C159.02186,176.493402 159.512266,176.493402 164.781836,175.22629 C131.289691,99.3815944 17.1351162,50.9507997 0.950279052,45.3452399 C0.030537201,34.9860744 -0.387114613,25.3291273 0.458652992,14.825585 Z",
    id: "Path-5",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Campo-superior",
    transform: "translate(154.656621, 130.492060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.42108547e-14,38.7531376 C25.9711733,46.2294622 49.0203844,54.3644316 79.2579609,67.5159712 C118.313524,49.1627337 144.861644,42.7575736 192.373916,37.7977491 C192.373916,25.1565598 190.728245,10.1801068 188.255597,0.241363308 C107.807925,-2.4955744 46.1438527,18.5279269 -1.42108547e-14,38.7531376 Z",
    id: "Path-6",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2579609,67.5159712 C111.729547,53.2897539 163.084322,47.3466821 192.264212,46.6640564 C191.654451,71.2565587 182.836911,101.580089 171.228495,121.193097 C143.264888,99.0106481 105.841636,78.8718254 79.2579609,67.5159712 Z",
    id: "Path-7",
    fill: "url(#linearGradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Espiga",
    transform: "translate(56.677265, 7.432178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.687162,457.602377 C178.455598,512.786262 63.6337463,432.895863 30.8118689,349.486799 C-13.9595308,256.286831 29.5081956,133.60669 122.242273,83.6732654 C113.089985,83.6732654 -48.682949,171.946893 14.6724011,349.486799 C54.8976139,452.717289 180.863651,521.622149 308.687162,457.602377 Z",
    id: "Rama",
    fill: "#F8B005"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grano",
    transform: "translate(123.457058, 106.226823) scale(1, -1) rotate(47.000000) translate(-123.457058, -106.226823) translate(103.957058, 82.726823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.131147291,46.906879 C3.01028118,39.1478968 0.798715198,25.4783862 7.00281781,17.7662531 C15.3092603,7.44076453 20.1350705,6.91992589 38.1864707,0.171695379 C37.78755,3.57540278 32.9351786,28.5023639 28.0760322,33.7131605 C22.1604406,43.9147006 4.65599517,45.6506353 0.131147291,46.906879 Z",
    id: "Path-2",
    fill: "#F8B005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.131147291,46.906879 C3.01028118,39.1478968 0.798715198,25.4783862 7.00281781,17.7662531 C15.3092603,7.44076453 17.8234055,7.96557975 35.8748057,1.21734925 C32.6513287,4.67410511 23.4630747,13.6415344 21.4575873,24.66111 C19.4520999,35.6806856 4.65599517,45.6506353 0.131147291,46.906879 Z",
    id: "Path-2-Copy",
    fill: "#F39600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grano",
    transform: "translate(159.322735, 89.067822) scale(1, -1) rotate(41.000000) translate(-159.322735, -89.067822) translate(139.322735, 64.567822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75470958,48.343941 C3.70531442,40.3749738 1.43884904,26.3355188 7.79696086,18.4146685 C16.3096006,7.80973638 21.2552055,7.27480203 39.7547096,0.343940971 C39.3458862,3.83976451 34.3730606,29.4413358 29.3932919,34.7931546 C23.330853,45.2707838 5.39188124,47.0536989 0.75470958,48.343941 Z",
    id: "Path-2",
    fill: "#F8B005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.775126202,48.3149287 C3.75545778,40.3334029 1.36300251,26.0795389 7.78517099,18.1462058 C16.3835738,7.52456092 18.9860878,8.06442893 37.6719705,1.12264521 C34.3351926,4.67854799 24.8239838,13.9031817 22.7480062,25.2388216 C20.6720286,36.5744614 5.4590164,47.0226533 0.775126202,48.3149287 Z",
    id: "Path-2-Copy",
    fill: "#F39600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grano",
    transform: "translate(197.322735, 76.067822) scale(1, -1) rotate(34.000000) translate(-197.322735, -76.067822) translate(177.322735, 51.567822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75470958,48.343941 C3.70531442,40.3749738 1.43884904,26.3355188 7.79696086,18.4146685 C16.3096006,7.80973638 21.2552055,7.27480203 39.7547096,0.343940971 C39.3458862,3.83976451 34.3730606,29.4413358 29.3932919,34.7931546 C23.330853,45.2707838 5.39188124,47.0536989 0.75470958,48.343941 Z",
    id: "Path-2",
    fill: "#F8B005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75470958,48.343941 C3.73504116,40.3624152 1.36300251,26.0795389 7.78517099,18.1462058 C16.3835738,7.52456092 18.9860878,8.06442893 37.6719705,1.12264521 C34.3351926,4.67854799 24.8239838,13.9031817 22.7480062,25.2388216 C20.6720286,36.5744614 5.43859978,47.0516656 0.75470958,48.343941 Z",
    id: "Path-2-Copy",
    fill: "#F39600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grano",
    transform: "translate(249.636022, 64.337091) scale(1, -1) rotate(24.000000) translate(-249.636022, -64.337091) translate(215.636022, 38.337091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8347131,18.62322 C43.2970667,14.9894979 49.3395658,12.1783503 52.9622104,10.1897771 C56.584855,8.20120397 61.4868148,4.9240746 67.6680897,0.358389021",
    id: "Line-2",
    stroke: "#F39600",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0257142222,51.0916151 C2.97631907,43.122648 3.06038123,25.8461455 10.1265638,18.8732445 C17.2297128,11.8638651 25.7910188,8.80910205 37.6705632,4.69811319 C37.2617398,8.19393673 34.6254703,29.3701985 30.0982455,36.7021015 C24.5895831,46.6739657 4.66288588,49.8013731 0.0257142222,51.0916151 Z",
    id: "Path-2",
    fill: "#F8B005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0257142222,51.0916151 C2.97631907,43.122648 3.06038123,25.8461455 10.1265638,18.8732445 C17.2297128,11.8638651 23.7952058,9.53018625 35.6747502,5.4191974 C31.357169,12.1307807 24.5284262,21.0822197 23.6090998,27.187913 C22.0497106,40.3808091 4.66288588,49.8013731 0.0257142222,51.0916151 Z",
    id: "Path-2-Copy-2",
    fill: "#F39600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grano",
    transform: "translate(108.322735, 72.067822) rotate(-5.000000) translate(-108.322735, -72.067822) translate(87.322735, 45.567822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.190213048,52.2607983 C0.190213048,39.549843 -1.48865522,27.1593379 5.12911056,18.3977576 C11.8296878,9.52653901 21.3885939,5.91062378 41.4772188,1.42108547e-14 C35.8701983,9.90893 33.3358564,27.4930393 27.1492314,35.5492765 C20.9626064,43.6055137 5.12911056,50.8639409 0.190213048,52.2607983 Z",
    id: "Path-2",
    fill: "#F8B005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.190213048,52.2607983 C0.190213048,39.549843 -1.48865522,27.1593379 5.12911056,18.3977576 C11.8296878,9.52653901 21.3885939,5.91062378 41.4772188,1.0658141e-14 C32.9772188,4.34797058 30.8662095,7.97045004 27.0007609,13.1841038 C23.1353124,18.3977576 21.7831504,27.833099 18.135892,32.8257878 C14.4886336,37.8184765 10.1775871,43.9795139 0.190213048,52.2607983 Z",
    id: "Path-2",
    fill: "#F39600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grano",
    transform: "translate(126.845516, 28.170065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.190213048,52.2607983 C0.190213048,39.549843 -1.48865522,27.1593379 5.12911056,18.3977576 C11.8296878,9.52653901 21.3885939,5.91062378 41.4772188,1.42108547e-14 C35.8701983,9.90893 33.3358564,27.4930393 27.1492314,35.5492765 C20.9626064,43.6055137 5.12911056,50.8639409 0.190213048,52.2607983 Z",
    id: "Path-2",
    fill: "#F8B005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.190213048,52.2607983 C0.190213048,39.549843 -1.48865522,27.1593379 5.12911056,18.3977576 C11.8296878,9.52653901 21.3885939,5.91062378 41.4772188,1.0658141e-14 C32.9772188,4.34797058 30.8662095,7.97045004 27.0007609,13.1841038 C23.1353124,18.3977576 21.7831504,27.833099 18.135892,32.8257878 C14.4886336,37.8184765 10.1775871,43.9795139 0.190213048,52.2607983 Z",
    id: "Path-2",
    fill: "#F39600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grano",
    transform: "translate(190.322735, 40.067822) rotate(8.000000) translate(-190.322735, -40.067822) translate(169.322735, 13.567822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.190213048,52.2607983 C0.190213048,39.549843 -1.48865522,27.1593379 5.12911056,18.3977576 C11.8296878,9.52653901 21.3885939,5.91062378 41.4772188,1.42108547e-14 C35.8701983,9.90893 33.3358564,27.4930393 27.1492314,35.5492765 C20.9626064,43.6055137 5.12911056,50.8639409 0.190213048,52.2607983 Z",
    id: "Path-2",
    fill: "#F8B005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.190213048,52.2607983 C0.190213048,39.549843 -1.48865522,27.1593379 5.12911056,18.3977576 C11.8296878,9.52653901 21.3885939,5.91062378 41.4772188,1.0658141e-14 C32.9772188,4.34797058 30.8662095,7.97045004 27.0007609,13.1841038 C23.1353124,18.3977576 21.7831504,27.833099 18.135892,32.8257878 C14.4886336,37.8184765 10.1775871,43.9795139 0.190213048,52.2607983 Z",
    id: "Path-2",
    fill: "#F39600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grano",
    transform: "translate(255.861440, 38.000000) rotate(17.000000) translate(-255.861440, -38.000000) translate(213.361440, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0535095,3.37057263 C74.5123363,3.99435424 66.1478089,5.11264656 58.9599271,6.72544961 C51.7720454,8.33825266 43.8309791,10.6587121 35.1367281,13.6868279",
    id: "Line",
    stroke: "#F39600",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.18802454,52 C0.18802454,39.3524765 -1.4715274,27.023804 5.07009725,18.3059468 C11.6935806,9.47899849 21.1425061,5.88112785 41,-7.10542736e-15 C35.4574915,9.85948123 32.9523086,27.3558401 26.8368642,35.371874 C20.7214198,43.387908 5.07009725,50.6101133 0.18802454,52 Z",
    id: "Path-2",
    fill: "#F8B005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.18802454,52 C0.18802454,39.3524765 -1.4715274,27.023804 5.07009725,18.3059468 C11.6935806,9.47899849 21.1425061,5.88112785 41,-7.10542736e-15 C32.5977973,4.32627279 30.5110763,7.9306749 26.690102,13.1183108 C22.8691276,18.3059468 21.532523,27.6942028 17.9272283,32.6619764 C14.3219337,37.62975 10.0604882,43.7600418 0.18802454,52 Z",
    id: "Path-2",
    fill: "#F39600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grano-final",
    transform: "translate(243.253752, 33.534777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5435526,2.40627702 C41.6793187,3.53923787 49.3008271,4.66046325 54.4080778,5.76995315 C59.5153285,6.87944306 66.4445064,8.91918246 75.1956116,11.8891713",
    id: "Line-3",
    stroke: "#F8B005",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5689828,18.5330459 C63.7950719,20.4529086 68.4739439,22.0307754 71.605599,23.2666465 C74.737254,24.5025176 79.416126,26.6175751 85.6422151,29.611819",
    id: "Line-4",
    stroke: "#F39600",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4513062,26.072176 C42.7000946,27.6262254 48.658778,28.876615 52.3273564,29.8233449 C55.9959348,30.7700748 60.7431436,32.3399752 66.5689828,34.5330459",
    id: "Line-5",
    stroke: "#F8B005",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.239610145,14.1809709 C0.239610145,12.6125836 9.78459703,1.41420682 15.873594,0.188990871 C45.8286427,-1.88573761 59.5037803,14.6786785 59.5037803,18.8046764 C59.5037803,22.9306743 34.4904726,30.0031416 15.873594,27.4241784 C10.8257716,26.5041548 0.239610145,15.7493581 0.239610145,14.1809709 Z",
    id: "Path-3",
    fill: "#F8B005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,14.0104807 C0,12.4420934 9.78459703,1.41420682 15.873594,0.188990871 C20.9620469,-0.163442482 26.6890401,-0.065227181 31.6608094,0.845651345 C39.955271,2.36528077 46.1404719,5.35400002 44.3866759,4.94481268 C20.5195125,-0.623760181 11.6591067,12.4182309 10.5028473,13.9164345 C12.2115857,15.0514363 15.6636616,21.1077844 23.5156508,24.0754875 C29.154536,26.2067356 38.3916917,25.3984891 44.3866759,25.5067924 C46.1883905,25.5067924 38.743008,27.0289848 31.048126,27.6152459 C24.9932778,28.0765553 18.9919463,27.9904842 16.2831966,27.6152459 C15.2414945,27.4253837 13.5385929,27.2275012 12.1391897,26.3542219 C6.75744196,22.9958126 0,15.2552052 0,14.0104807 Z",
    id: "Path-3",
    fill: "#F39600"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbast05);
export default __webpack_public_path__ + "static/media/abast05.4a68af7d62c3a61a55c2579fa155685e.svg";
export { ForwardRef as ReactComponent };